import { DefaultValues } from "react-hook-form";
import * as yup from "yup";

export const baseNomenclatureSchema = yup
  .object({
    id: yup
      .number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value
      )
      .optional(),
    name: yup.string().required("Името е задължително").defined(),
    isDeleted: yup.boolean().optional(),
  })
  .required();

export type IBaseNomenclatureInputModel = yup.InferType<
  typeof baseNomenclatureSchema
>;

export const baseNomenclatureDefaults: DefaultValues<IBaseNomenclatureInputModel> =
  {
    name: "",
  };
